module.exports = __webpack_public_path__ + "media/images/flags/4x3/cck-7375ca014f01c2c6fbe0078f7212638e.svg";